interface TableRowVisualStateOptions {
	isDeleted: boolean
	isMuted: boolean
}

export const getTableRowVisualState = ({
	isDeleted,
	isMuted,
}: TableRowVisualStateOptions) => {
	if (isDeleted) {
		return {
			cellBackground: '#fff1f2',
			rowBackground: '#fff1f2',
			hoverBackground: '#ffe4e6',
			contentColor: undefined,
			contentFilter: undefined,
			contentOpacity: undefined,
		}
	}

	if (isMuted) {
		return {
			cellBackground: '#f3f4f6',
			rowBackground: '#f3f4f6',
			hoverBackground: '#e5e7eb',
			contentColor: '#6b7280',
			contentFilter: 'grayscale(1)',
			contentOpacity: 0.62,
		}
	}

	return {
		cellBackground: 'inherit',
		rowBackground: '#ffffff',
		hoverBackground: '#f8fafc',
		contentColor: undefined,
		contentFilter: undefined,
		contentOpacity: undefined,
	}
}
